import type {ContainerQueryObject} from '@Hooks/useContainerQuery';
import type {AiPromptBoxAttachments} from '@Components/ai-prompt-box/components/ai-prompt-box-attachments/ai-prompt-box-attachments.types';
import type {ChatMessage, ImagePart, RequestConfig, TextPartPurpose} from '@Components/ai-chat-window/ai-chat-window.types';

export interface LightboxImageEntry {
  part: ImagePart;
  messageId: string | undefined;
  uniqueKey: string;
}

export interface ChatMessagesDisplayProps {
  messages: Record<string, ChatMessage>;
  chatId: string | undefined;
  bubbleClassNames: string;
  onRetry: () => Promise<void>;
  onMessageRefMount: (container: HTMLDivElement) => void;
  onRegenerate: (prompt?: string, requestConfig?: RequestConfig, purpose?: TextPartPurpose) => void;
  onGenerate: (prompt: string, promptAttachments?: AiPromptBoxAttachments, requestConfig?: RequestConfig, purpose?: TextPartPurpose) => Promise<void>;
  onReattach: (part: ImagePart, previewUrl?: string) => void;
  onEditSend?: (messageKey: string, newText: string) => void;
  editSendInProgressMessageKey?: string | null;
  waitingForRefreshedChatToFinish?: boolean;
  isMessageStreaming: boolean;
  heightAdjustmentForFloatingPromptBox?: number;
}

export const CHAT_MESSAGES_NARROW_MAX_WIDTH = 420;

export const CHAT_MESSAGES_NARROW_QUERY: ContainerQueryObject = {
  narrow: {maxWidth: CHAT_MESSAGES_NARROW_MAX_WIDTH},
};
